<div class="discussion-header commentSection" (mouseover)="markHover(true, comment.id)" (mouseleave)="markHover(false, comment.id)"
  [class.showPointer]="numberOfChildrenComments > 0">
  <div style="position: relative; display: flex;">
    @if (numberOfChildrenComments > 0) {
      <div class="numberBadge">{{numberOfChildrenComments}}</div>
    }
    @if (isShowDiscussionIcon) {
      <mat-icon #discussionIconAvatar class="discussionIcon"
        insTooltip [delayMs]="700" [cfg]="{text: userName, position: {H: 'hLeft', V:'vTop'}, type: 'info'}">
        <div class="acronyms">{{acronymsUserName}}</div>
      </mat-icon>
    }
  </div>
  <div class="showTextArea" [ngStyle]="replayStyle">

    <div class="comment-text">
      <div style="display: flex; justify-content: space-between; align-items: center">
        <div class="commentCreationDate">
          <div>{{comment.creationDate}}</div>
        </div>
        <div class="iconWithNum">
          @if (hover[comment.id]) {
            <div>
              @if (isPermDeleteComment) {
                <mat-icon class="commentIcon controlButton" svgIcon="app.delete" (click)="onDeleteComment($event, comment)"></mat-icon>
              }
              @if (isPermAddComment && +comment.parentId === 0) {
                <mat-icon class="commentIcon controlButton" svgIcon="reply.discussion" (click)="replayToComment($event)"></mat-icon>
              }
            </div>
          }
          @if (isPermLike && (+comment.numLikes > 0 || hover[comment.id])) {
            <div class="likesComp">
              <mat-icon class="commentIcon likeIcon" [class.path]="comment.isCommentLikedByUser" svgIcon="like.discussion" (click)="likeOrUnlikeComment($event)"></mat-icon>
              @if (+comment.numLikes > 0) {
                <div style="line-height: 16px; padding: 4px 4px 4px 0">{{comment.numLikes}}</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="commentText">{{comment.text}}</div>
    </div>
    <div>
    </div>
  </div>
</div>
@if (isPermAddComment && isReplayToExistComment) {
  <div>
    <ins-discussion-textarea [isShowDiscussionIcon]="true" [comment]="comment"
      (cancelNewComment)="isReplayToExistComment=$event"
      (createComment)="onCreateNewComment($event, comment)"
    [placeholder]=undefined></ins-discussion-textarea>
  </div>
}
